module.exports = __webpack_public_path__ + "img/solution_1.b277eabc.png";